import createModel, { prop } from './lib/create_model';

export const InstagramBusinessAccount = createModel({
  modelName: 'InstagramBusinessAccount',
  properties: {
    id: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const FbPageAccountContent = createModel({
  modelName: 'FbPageAccountContent',
  properties: {
    id: prop(String).isRequired,
    instagramBusinessAccount: prop(InstagramBusinessAccount),
    isTemporaryToken: Boolean,
    name: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FbPageAccountContent;
